import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[appMarginRight]',
    standalone: false
})
export class MarginRightDirective {
  constructor(element: ElementRef) {
    element.nativeElement.style.marginRight = '16px';
  }
}
